'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n        color: ', ';\n        font-family: acumin-pro;\n        \n        \n        text-align: ', ';\n        text-transform: ', ';\n\n        h1, h2, h3, h4, h5, h6, span {\n            font-size: ', ';\n            font-weight: ', ';\n            letter-spacing: ', ';\n        }\n       \n        @media screen and (max-width: 375px) {\n            h1, h2, h3, h4, h5, h6, span {\n                font-size: ', ';\n            }\n            \n        }\n    '], ['\n        color: ', ';\n        font-family: acumin-pro;\n        \n        \n        text-align: ', ';\n        text-transform: ', ';\n\n        h1, h2, h3, h4, h5, h6, span {\n            font-size: ', ';\n            font-weight: ', ';\n            letter-spacing: ', ';\n        }\n       \n        @media screen and (max-width: 375px) {\n            h1, h2, h3, h4, h5, h6, span {\n                font-size: ', ';\n            }\n            \n        }\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../styles/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Heading = function Heading(_ref) {
    var children = _ref.children,
        headingSize = _ref.headingSize,
        headingText = _ref.headingText,
        headingColor = _ref.headingColor,
        isCentered = _ref.isCentered,
        headingTag = _ref.headingTag;


    var fontSize = void 0,
        fontSizeMobile = void 0,
        fontWeight = void 0;

    if (headingSize === 'xxlarge') {
        fontSize = '48px';
        fontSizeMobile = '32px';
        fontWeight = '900';
    }

    if (headingSize === 'xlarge') {
        fontSize = '36px';
        fontSizeMobile = '26px';
        fontWeight = '900';
    }

    if (headingSize === 'large') {
        fontSize = '26px';
        fontSizeMobile = '22px';
        fontWeight = '500';
    }

    if (headingSize === 'medium') {
        fontSize = '22px';
        fontSizeMobile = '18px';
        fontWeight = '600';
    }

    if (headingSize === 'small') {
        fontSize = '18px';
        fontSizeMobile = '16px';
        fontWeight = '500';
    }

    if (headingSize === 'xxsmall') {
        fontSize = '12px';
        fontSizeMobile = '11px';
        fontWeight = '500';
    }

    var HeadingStyled = _styledComponents2.default.div(_templateObject, headingColor ? headingColor : _colors2.default.grayscaleCoolGray11, isCentered ? "center" : null, headingSize === 'xxsmall' ? 'uppercase' : 'none', fontSize, fontWeight, headingSize === "xxsmall" ? "2.5px" : "normal", fontSizeMobile);

    return _react2.default.createElement(
        HeadingStyled,
        { className: 'heading-component' },
        headingTag === "h1" ? _react2.default.createElement(
            'h1',
            null,
            headingText,
            children
        ) : null,
        headingTag === "h2" ? _react2.default.createElement(
            'h2',
            null,
            headingText,
            children
        ) : null,
        headingTag === "h3" ? _react2.default.createElement(
            'h3',
            null,
            headingText,
            children
        ) : null,
        headingTag === "h4" ? _react2.default.createElement(
            'h4',
            null,
            headingText,
            children
        ) : null,
        headingTag === "h5" ? _react2.default.createElement(
            'h5',
            null,
            headingText,
            children
        ) : null,
        headingTag === "h6" ? _react2.default.createElement(
            'h6',
            null,
            headingText,
            children
        ) : null,
        !headingTag ? _react2.default.createElement(
            'span',
            null,
            headingText,
            children
        ) : null
    );
};

exports.default = Heading;


//////////////////
// WEBPACK FOOTER
// ./~/pubweb-react-components/dist/components/Typography/Heading.js
// module id = 44
// module chunks = 168707334958949